<template>
  <li class="navbar__pages row" @mouseenter="openDropdown" @mouseleave="closeDropdown">
    <PageLink :to="to" class="navbar__link row -align-center" :class="{ '-push-right': hasDropdown }">
      {{ label }}
    </PageLink>

    <span v-if="hasDropdown" class="navbar__link-plus" @click.stop="toggleDropdown">&plus;</span>

    <DropDown
      v-if="hasDropdown"
      :is-open="isDropdownOpen"
      class="navbar__dropdown"
      content-class="navbar__dropdown-list"
      @click.native.stop
    >
      <RouterLink
        v-for="(anchorLabel, targetId) in anchors"
        :key="targetId"
        :to="getAnchorLink(`#${targetId}`)"
        class="navbar__anchor"
        @click.native="onClickAnchor"
      >
        {{ anchorLabel[$lang.current] }}
      </RouterLink>
    </DropDown>
  </li>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    label: { type: String, default: '' },
    to: { type: Object, default: null },
    anchors: { type: Object, defaut: null }
  },
  data() {
    return {
      isDropdownOpen: false
    }
  },
  computed: {
    hasDropdown() {
      return this.anchors && Object.keys(this.anchors).length > 0
    }
  },
  mounted() {
    this.$globalEvent.on('close-dropdowns', this.closeDropdown)
  },
  beforeDestroy() {
    if (this.isDropdownOpen) document.body.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    getAnchorLink(hash) {
      return { ...this.to, hash }
    },
    toggleDropdown() {
      if (this.isDropdownOpen) {
        document.body.removeEventListener('click', this.closeDropdown)
      } else {
        document.body.addEventListener('click', this.closeDropdown)
        this.$globalEvent.emit('close-dropdowns')
      }

      this.isDropdownOpen = !this.isDropdownOpen
    },
    openDropdown() {
      this.isDropdownOpen = true
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    onClickAnchor() {
      this.closeDropdown()
    }
  }
}
</script>
